import { render } from "./AdvAuthorization.vue?vue&type=template&id=bab0a2fe"
import script from "./AdvAuthorization.vue?vue&type=script&lang=js"
export * from "./AdvAuthorization.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__